import { Reveal, SectionTitle } from "@/components/site/Reveal";
import { GALLERY } from "@/data/content";
import { motion } from "framer-motion";

export const Galerie = () => (
  <section id="galerie" className="py-20 sm:py-28 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <SectionTitle
          overline="Galerie"
          title="Nos créations gourmandes"
          subtitle="Coupes familiales, cornets maxi ou classiques, avec ou sans toppings : un aperçu de nos glaces faites maison."
        />
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {GALLERY.map((item, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08}>
            <motion.div whileHover={{ scale: 1.02 }} data-testid={`gallery-${i}`} className={`group relative overflow-hidden rounded-3xl shadow-soft ${i % 5 === 0 ? "md:row-span-2" : ""}`}>
              <img src={item.src} alt={item.caption} className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i % 5 === 0 ? "h-full min-h-[300px]" : "h-56"}`} loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-chocolate/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <p className="absolute bottom-3 left-4 right-4 text-cream text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">{item.caption}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
